export default __webpack_public_path__ + "eed686e02846b9cea97e6d4fdd24d36b.png";